import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const giftWithPurchaseRolesRBAC = {
  pageID: '922e3b30864ff78c11d273d4e2b65198',
  elementID: {
    ViewGWPPage: '8ad7fd2fb06d5592709d630155190322',
    ToggleStatus: 'e651090d342c62a0d7b08a69e79c62ec',
    ButtonEdit: '689f3cfada47c5f5e218702887e352f4',
    ButtonCreate: 'fb93def64496fd3473e7088a54885b1e',
  },
} as const

export const useRBACGiftWithPurchasePage = createUseRBAC(giftWithPurchaseRolesRBAC.elementID)

export type UseRBACGiftWithPurchasePageType = ReturnType<typeof useRBACGiftWithPurchasePage>
